import React, { useState } from 'react';

import { CollapserIcon } from './CollapserIcon';
import { twMerge } from 'tailwind-merge';

type CollapserProps = {
  header: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  stretch?: boolean;
  topClassName?: string;
  topOpenedClassName?: string;
  headerClassName?: string;
  defaultCollapsed?: boolean;
};

const Collapser: React.FC<CollapserProps> = ({
  header,
  children,
  className,
  topClassName,
  topOpenedClassName = 'border-b',
  headerClassName = 'font-medium text-tiny text-header',
  stretch = true,
  defaultCollapsed = false,
}) => {
  const [show, setShow] = useState(!defaultCollapsed);

  return (
    <div className={twMerge('flex flex-col', className)}>
      <div
        className={twMerge(
          'flex flex-row cursor-pointer items-center',
          topClassName,
          show && topOpenedClassName,
          stretch ? '' : 'w-fit'
        )}
        onClick={() => setShow(s => !s)}
      >
        <div className={headerClassName}>{header}</div>
        <div className="flex items-center justify-center ml-sm mr-md">
          <CollapserIcon show={show} />
        </div>
      </div>
      {!!show && children}
    </div>
  );
};

export default React.memo(Collapser) as typeof Collapser;
